// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-section {
  width: 100vw;
  background: #f8fafc;
  padding: 64px 0;
  display: flex;
  justify-content: center;
}

.faq-container {
  max-width: 900px;
  width: 95vw;
  margin: 0 auto;
}

.faq-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.faq-title {
  font-family: 'Montserrat', Arial, sans-serif;
  font-size: 2.5rem;
  font-weight: 900;
  color: #222;
  margin-bottom: 32px;
  letter-spacing: 1px;
  text-align: left;
}

.faq-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.faq-item {
  margin-bottom: 28px;
  padding-bottom: 18px;
  border-bottom: 1px solid #e5e7eb;
  animation: fadeInUp 0.7s;
}

.faq-item h3 {
  font-size: 1.15rem;
  font-weight: 700;
  color: #4f7cff;
  margin-bottom: 8px;
  font-family: 'Montserrat', Arial, sans-serif;
}

.faq-item p {
  font-size: 1rem;
  color: #444;
  margin: 0;
  font-family: 'Montserrat', Arial, sans-serif;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(40px);}
  to { opacity: 1; transform: translateY(0);}
}

@media (max-width: 900px) {
  .faq-title {
    font-size: 2rem;
  }
}

@media (max-width: 600px) {
  .faq-section {
    padding: 32px 0;
  }
  .faq-title {
    font-size: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FAQ1.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,CAAC;EAC/C,KAAK,UAAU,EAAE,wBAAwB,CAAC;AAC5C;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".faq-section {\n  width: 100vw;\n  background: #f8fafc;\n  padding: 64px 0;\n  display: flex;\n  justify-content: center;\n}\n\n.faq-container {\n  max-width: 900px;\n  width: 95vw;\n  margin: 0 auto;\n}\n\n.faq-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.faq-title {\n  font-family: 'Montserrat', Arial, sans-serif;\n  font-size: 2.5rem;\n  font-weight: 900;\n  color: #222;\n  margin-bottom: 32px;\n  letter-spacing: 1px;\n  text-align: left;\n}\n\n.faq-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.faq-item {\n  margin-bottom: 28px;\n  padding-bottom: 18px;\n  border-bottom: 1px solid #e5e7eb;\n  animation: fadeInUp 0.7s;\n}\n\n.faq-item h3 {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #4f7cff;\n  margin-bottom: 8px;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n.faq-item p {\n  font-size: 1rem;\n  color: #444;\n  margin: 0;\n  font-family: 'Montserrat', Arial, sans-serif;\n}\n\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(40px);}\n  to { opacity: 1; transform: translateY(0);}\n}\n\n@media (max-width: 900px) {\n  .faq-title {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .faq-section {\n    padding: 32px 0;\n  }\n  .faq-title {\n    font-size: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
